export const PERSONAL_DETAILS_CONFIG = ["firstName", "lastName", "title", "dateOfBirth", "gender", "externalAgentIdentifier"];
export const IDENTITY_DETAILS_CONFIG = ["idType", "idNumber", "idExpiryDate", "idIssuingCountry", "nationality"];
export const ADDRESS_DETAILS_CONFIG = ["streetNumber", "streetName", "suburb", "city", "province", "postalCode"];
export const CONTACT_DETAILS_CONFIG = ["phoneNumber", "alternativePhoneNumber", "email"];
export const DOCUMENT_DETAILS_CONFIG = ["idType"];

export const TITLES = [
    {id: "MR", name: "Mr"},
    {id: "MRS", name: "Mrs"},
    {id: "MISS", name: "Miss"},
    {id: "MS", name: "Ms"},
];

export const GENDER = [
    {id: "FEMALE", name: "Female"},
    {id: "MALE", name: "Male"}
]
export const AGENTS = [
    {id: "STORE", name: "Store"},
    {id: "PERSON", name: "Person"}
]

export const ID_TYPES = [
    {id: "SA_ID", name: "SA ID"},
    {id: "ASYLUM_PAPER", name: "Asylum Paper"},
    {id: "FOREIGN_PASSPORT", name: "Foreign Passport"}
];
export const BUTTON_HEADERS = {

    "Identity": {
        "buttonHeader": "Photo of the Agent's Identity Document",
        "buttonText": "Document"
    },
    "Picture": {
        "buttonHeader": "Photo of the Agent",
        "buttonText": "Picture"
    },

};





